import React from 'react';
import styled from 'styled-components';
import { detect } from 'detect-browser';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

const Wrapper = styled.div`
  padding: 1.25rem;
  display: block;
  background: white;
  color: black;
  a {
    text-decoration: underline;
  }
`;

function UnsupportedBrowserMessage() {
  const { tt } = useUiComponentsInternationalContext();
  const browser = detect();
  return browser?.name === 'ie' ? (
    <Wrapper>
      <p>
        {tt(
          s => s.unsupportedBrowserMessageComponent.unsupportedBrowserMessage,
          {
            link: (
              <a
                href="https://browsehappy.com/"
                target="_blank"
                rel="noreferrer"
              >
                {tt(
                  s =>
                    s.unsupportedBrowserMessageComponent.upgradeYourBrowserLink
                )}
              </a>
            ),
          }
        )}
      </p>
    </Wrapper>
  ) : (
    ''
  );
}

export default UnsupportedBrowserMessage;
